import { LOG_LEVEL } from 'src/logger/log-level';

/**
 * Local developer transport. Does not send anything to AWS.
 *
 * @param {Object} [options]
 * @param {boolean} [options.enabled]
 * @returns {{ log: Function }}
 */
export const createConsoleTransport = ({
    enabled = process.env.NODE_ENV !== 'production',
} = {}) => ({
    log(record) {
        if (!enabled || !record) {
            return;
        }

        const payload = {
            ...(record.eventType ? { eventType: record.eventType } : {}),
            ...(record.meta || {}),
        };
        const args = Object.keys(payload).length > 0
            ? [record.message, payload]
            : [record.message];

        switch (record.level) {
            case LOG_LEVEL.DEBUG:
                console.debug(...args);
                break;
            case LOG_LEVEL.INFO:
                console.info(...args);
                break;
            case LOG_LEVEL.WARN:
                console.warn(...args);
                break;
            case LOG_LEVEL.ERROR:
                console.error(...args);
                break;
            default:
                console.log(...args);
        }
    },
});
